import { Card, Text } from "@mantine/core";
import classes from "./WebOrder.module.css";

// Correct: destructure both props from a single object
interface ScoreCardProps {
  score: number | string;
  title: string;
}

export default function ScoreCard({ score, title }: ScoreCardProps) {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder className={classes.card}>
      <Text fw={700} fz="xl" color="blueviolet">{score}</Text>
      <Text fw={700} fz="md" className={classes.cardTitle}>{title}</Text>
    </Card>
  );
}
